import React, {Component} from 'react';
import database from "../../services/firebase";

import HeaderBlock from "../../components/HeaderBlock";
import Header from "../../components/Header";
import Paragraph from "../../components/Paragraph";
import ContentBlock from "../../components/ContentBlock";
import FooterBlock from "../../components/FooterBlock";

import CardList, { hoc } from "../../components/CardList";
import Card from '../../components/Card';

import s from "./Home.module.scss";
import TestContext from "../../context/testContext";
import FirebaseContext, {withFirebase} from "../../context/firebaseContext";

class HomePage extends Component {
    state = {
        wordArr: [],
        valueEnglish: '',
        valueRussian: '',
        valueUrl: '',
        label: '',
    }

    inputRef = React.createRef();

    componentDidMount() {
        console.log(this.props);
        const {getUserCardsRef} = this.props.firebase;
        getUserCardsRef().on('value', res => {
            this.setState({
                wordArr: res.val() || [],
            })
        })
    }

    setNewWord = () => {
        const {getUserCardsRef} = this.context;
        const {wordArr} = this.state;
        getUserCardsRef().set([...wordArr, {
            img: this.state.valueUrl,
            eng: this.state.valueEnglish,
            rus: this.state.valueRussian,
            id: (this.state.wordArr.length + 1),
        }]);
    }

    handleDeletedItem = (id) => {
        const {getUserCardsRef} = this.context;
        const {wordArr} = this.state;

        const newWordArr = wordArr.filter(item => item.id !== id);

        getUserCardsRef().set(newWordArr);
    }

    handleInputChangeEnglish = (e) => {
        this.setState({
            valueEnglish: e.target.value
        });
    }

    handleInputChangeRussian = (e) => {
        this.setState({
            valueRussian: e.target.value
        });
    }

    handleInputChangeUrl = (e) => {
        this.setState({
            valueUrl: e.target.value
        });
    }

    handleSubmitForm = (e) => {
        e.preventDefault();
        this.setNewWord();
    }

    render() {
        const {wordArr} = this.state;
        const {valueEnglish, valueRussian, valueUrl} = this.state;
        return (
            <>
                <HeaderBlock
                    img='url("./img/background.jpg")'
                    background="red"
                >
                    <Header>
                        Время учить слова онлайн
                    </Header>
                    <Paragraph>
                        Воспользуйтесь карточками для запоминания
                        и пополнения активныйх словарных запасов
                    </Paragraph>
                    <button className={s.buttonAdd} onClick={() => {
                        this.inputRef.current.focus();
                    }}
                    >
                        Начать бесплатно урок
                    </button>
                </HeaderBlock>

                <ContentBlock
                    background="steelblue"
                >
                    <Header>
                        Начать учить английський просто
                    </Header>
                    <Paragraph>
                        Кликай по карточкам и узнавай новые слова, быстро и легко!
                    </Paragraph>
                    <form
                        className={s.formAdd}
                        onSubmit={this.handleSubmitForm}>
                        <input
                            ref={this.inputRef}
                            type="text"
                            placeholder="New world english"
                            value={this.state.valueEnglish}
                            onChange={this.handleInputChangeEnglish}
                        />
                        <input
                            type="text"
                            placeholder="Новое слово на русском"
                            value={this.state.valueRussian}
                            onChange={this.handleInputChangeRussian}
                        />
                        <input
                            type="text"
                            placeholder="Url картинки"
                            value={this.state.valueUrl}
                            onChange={this.handleInputChangeUrl}
                        />
                        <button>
                            Add New Word
                        </button>
                    </form>
                    <TestContext.Consumer>
                        {
                            () => {
                                const CardEngList = hoc(Card, wordArr, this.handleDeletedItem);
                                return <CardEngList/>
                            }
                        }
                    </TestContext.Consumer>

                </ContentBlock>
                <HeaderBlock
                    background="black"
                >
                    <Header>
                        Учите слова онлайн
                    </Header>
                    <Paragraph>
                        Воспользуйтесь карточками для запоминания
                        и пополнения активныйх словарных запасов
                    </Paragraph>
                </HeaderBlock>
                <FooterBlock
                    cop="Company 2020"
                />
            </>
        );
    }
}
HomePage.contextType = FirebaseContext;

export default withFirebase(HomePage);